module.exports = __webpack_public_path__ + "static/media/usage_box.e0a97401.png";